export enum RespondentMinorStatus {
  DownloadedForOfflineSigning = 'Downloaded for offline signing',
  ManuallyMarkedComplete = 'Manually marked complete',
  SignedOffline = 'Signed offline',
}
